import React, { useEffect, useState } from "react";
import MenuLayouts from "../layouts/menu.layout";
import FooterLayouts from "../layouts/footer.layout";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  FinanceAll,
  FinanceOne,
} from "../components/conexion/finance.conexion";

import BannerGeneralComponent from "../components/hyundai_finance/banner.component";
import FinanzasPromesaComponent from "../components/hyundai_finance/promesa.component";
import FinanzasServiciosComponent from "../components/hyundai_finance/servicios.component";
import FinanzasSimulatorComponent from "../components/hyundai_finance/simulator.component";
import FinanzasOportunidadesComponent from "../components/hyundai_finance/oportunidades.component";

/*eslint-disable */

declare const window: any;

const HyundaiFinancePage: React.FC = () => {
  const [visibleHeight, setVisibleHeight] = useState(0);
  const navigate = useNavigate();

  const [dataFinance, setDataFinance]: any = useState({});
  const [opportunities, setOpportunities]: any = useState([]);
  const [benefits, setBenefits]: any = useState([]);
  const [services, setServices]: any = useState([]);

  useEffect(() => {
    FinanceAll().then(function (res: any) {
      console.log(res?.data);
      const data = res?.data?.data[0];
      setDataFinance(data);

      // let opportunities: any = [];
      // opportunities.push(data.opportunity1);
      // opportunities.push(data.opportunity2);
      // opportunities.push(data.opportunity3);
      // setOpportunities(opportunities);
      setOpportunities(
        res?.data?.data[0]?.opportunity1 &&
          res?.data?.data[0]?.opportunity2 &&
          res?.data?.data[0]?.opportunity3
          ? [
              res?.data?.data[0]?.opportunity1,
              res?.data?.data[0]?.opportunity2,
              res?.data?.data[0]?.opportunity3,
            ]
          : []
      );

      let benefits: any = [];
      benefits.push(data.benefit1);
      benefits.push(data.benefit2);
      benefits.push(data.benefit3);
      benefits.push(data.benefit4);
      benefits.push(data.benefit5);
      setBenefits(benefits);

      setServices(data.services);

    });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      const dataLayerEvent: any = {
        event: "hyundai_finance_click",
        comp_page: {
          position: "top menu",
        },
      };

      // Empujar al dataLayer
      if (window.dataLayer) {
        window.dataLayer.push(dataLayerEvent);
      }
    }, 0);
  }, []);

  return (
    <>
      <MenuLayouts
        className="home-page"
        active="hyundai-finance"
        setVisibleHeight={setVisibleHeight}
        visibleHeight={visibleHeight}
      />
      <div
        className="home-page" style={{scrollBehavior: "smooth"}}/* style={{backgroundColor: "#F6F3F2", height: "100vh"}} */
      >
        <BannerGeneralComponent
          banner={
            dataFinance.banner ? dataFinance.banner : {}
          }
        />
        <FinanzasPromesaComponent data={dataFinance} benefits={benefits}/>
        <FinanzasServiciosComponent services={services} navigate={navigate}/>
        <FinanzasSimulatorComponent />
        <FinanzasOportunidadesComponent opportunities={opportunities} />
      </div>

      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      <FooterLayouts />
    </>
  );
};

export default HyundaiFinancePage;
